import babsonImg from "../../assets/international/babson.png";
import chinaImg from "../../assets/international/china.png";
import disneyImg from "../../assets/international/disney.png";
import estoniaImg from "../../assets/international/estonia.png";
import lodgeBerlinImg from "../../assets/international/lodge_berlin.png";
import lodgeBostonImg from "../../assets/international/lodge_boston.png";
import lodgeMadridImg from "../../assets/international/lodge_madrid.png";
import lodgePaloImg from "../../assets/international/lodge_palo_alto.png";
import madridImg from "../../assets/international/madrid.png";
import onlineTelavivImg from "../../assets/international/online_telaviv.png";
import stanfordImg from "../../assets/international/stanford.png";
import whartonImg from "../../assets/international/wharton.png";

import BoletimSection from "../BoletimSection/BoletimSection";
import CardImageGrid from "../CardImageGrid/CardImageGrid";

function ExperienciaInternacional({ experiencias, highlight }) {
	const EXPERIENCIAS_OPTIONS = {
		Lodges: [
			{
				desc: "Lodge Berlim",
				image: lodgeBerlinImg,
				disabled: experiencias.includes("lodge_berlim") ? false : true,
				show: experiencias.includes("lodge_berlim") ? true : false,
			},
			{
				desc: "Lodge Boston",
				image: lodgeBostonImg,
				disabled: experiencias.includes("lodge_boston") ? false : true,
				show: true,
			},
			{
				desc: "Lodge Madrid",
				image: lodgeMadridImg,
				disabled: experiencias.includes("lodge_madrid") ? false : true,
				show: true,
			},
			{
				desc: "Lodge Palo Alto",
				image: lodgePaloImg,
				disabled: experiencias.includes("lodge_palo_alto")
					? false
					: true,
				show: true,
			},
		],
		"Programas Presenciais": [
			{
				desc: "Disney",
				image: disneyImg,
				disabled: experiencias.includes("disney") ? false : true,
				show: true,
			},
			{
				desc: "Madrid",
				image: madridImg,
				disabled: experiencias.includes("madrid") ? false : true,
				show: true,
			},
			{
				desc: "China",
				image: chinaImg,
				disabled: experiencias.includes("china") ? false : true,
				show: true,
			},
            {
				desc: "Estônia",
				image: estoniaImg,
				disabled: experiencias.includes("estonia") ? false : true,
				show: true,
			},
		],
		"Programas Online": [
			{
				desc: "Stanford",
				image: stanfordImg,
				disabled: experiencias.includes("stanford") ? false : true,
				show: true,
			},
			{
				desc: "Wharton",
				image: whartonImg,
				disabled: experiencias.includes("wharton") ? false : true,
				show: experiencias.includes("wharton") ? true : false,
			},
			{
				desc: "Babson",
				image: babsonImg,
				disabled: experiencias.includes("babson") ? false : true,
				show: experiencias.includes("babson") ? true : false,
			},
			{
				desc: "Tel Aviv",
				image: onlineTelavivImg,
				disabled: experiencias.includes("tau") ? false : true,
				show: true,
			},
		],
	};
	return (
		<BoletimSection
			title="Experiências Internacionais"
			icon="globe"
		>
			<CardImageGrid
				type={"exp"}
				items={EXPERIENCIAS_OPTIONS}
				highlight={highlight}
                hasSections={true}
			/>
		</BoletimSection>
	);
}

export default ExperienciaInternacional;
